import { Country, CountryGroup } from "Store/texts/interfaces";
import { FormikErrors, FormikProps } from "formik";

import { SearchItem } from "@storeblocks/autosuggest";
import { TextManager } from "Components/TextContext";
import { isDefined } from "Utils/functions";
import { getError } from "Utils/productUtils";
import { AkaStudentProductIntroFormValues } from "./akaStudentProductIntroInterfaces";

export const mapToCountries = (optionsList: CountryGroup[]): Country[] =>
  optionsList
    .map((countryGroup) =>
      countryGroup.countries.map((country: string) => ({
        code: countryGroup.code,
        name: country,
      })),
    )
    .flatMap((country) => country);

export const mapToSearchItems = (optionsList: CountryGroup[]): SearchItem[] => {
  const countries = mapToCountries(optionsList);
  return countries
    .map((country) => ({
      label: country.name,
      value: country.name,
    }))
    .sort((a, b) => a.label.localeCompare(b.label));
};

export const isCountryNotAllowed = (
  country: string | undefined,
  countriesNotAllowed: string[],
): boolean => {
  if (!isDefined(country)) {
    return false;
  }
  return countriesNotAllowed.some(
    (c) => c.toLocaleLowerCase() === country.toLocaleLowerCase(),
  );
};

export const findCountry = (
  country: string | undefined,
  countries: Country[],
): Country | undefined => {
  if (!isDefined(country)) {
    return undefined;
  }
  return countries.find(
    (c) => c.name.toLocaleLowerCase() === country.toLocaleLowerCase(),
  );
};

export const getNoItemsFoundText = (
  formProps: FormikProps<AkaStudentProductIntroFormValues>,
): string => {
  const { getText } = TextManager;

  if (
    !isDefined(formProps.values.country) ||
    !isDefined(formProps.values.region)
  ) {
    return getText("akastudentform.validation.country_invalid");
  }

  return getError("country", formProps);
};

export const filterRegionError = (
  errors: FormikErrors<AkaStudentProductIntroFormValues>,
): FormikErrors<AkaStudentProductIntroFormValues> => {
  const filteredErrors = { ...errors };
  delete filteredErrors.region;
  return filteredErrors;
};
